import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '../../components';
import { adminLogin } from '../../service';
import { toast } from 'react-toastify';
import AdminBrandLayout from '../../components/admin/brandLayout';

const AdminLogin = () => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [emailValue, setEmailValue] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    try {
      setSubmitting(true);
      setSuccess(false);
      setError(false);
      await adminLogin({ email: emailValue });
      setError(false);
      setSuccess(true);
      toast.success(t('login.success'));
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminBrandLayout>
      <section className="w-full text-center" aria-labelledby="admin-login-heading">
        <h1
          id="admin-login-heading"
          className="m-0 font-poppins text-[clamp(28px,2.58vw,48px)] font-extrabold leading-[1.25] text-blue-10">
          {t('admin.login.heading.groupes')} {t('admin.login.heading.cnat')}
        </h1>
        <p className="mt-[14px] mx-auto max-w-[1000px] font-inter text-[clamp(16px,1.29vw,24px)] font-semibold leading-[1.5] text-gray-10">
          {t('admin.login.subHeading')}
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col md:flex-row items-stretch gap-4 w-full max-w-[38rem] mx-auto mt-[clamp(48px,5.48vw,102px)]"
          aria-busy={submitting}>
          <div className="flex-1 min-w-0">
            <label htmlFor="admin-email" className="sr-only">
              {t('admin.login.emailPlaceholder')}
            </label>
            <input
              type="email"
              name="email"
              id="admin-email"
              autoComplete="email"
              required
              placeholder={t('admin.login.emailPlaceholder')}
              className="w-full h-[70px] rounded-2xl border-0 px-8 py-4 font-inter text-base leading-[1.5] bg-gray-20 text-gray-10 placeholder:text-gray-10 placeholder:opacity-100 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#4f4898] focus-visible:outline-offset-4"
              value={emailValue}
              onChange={(e) => setEmailValue(e.target.value)}
            />
          </div>
          <Button
            type="submit"
            text={t('admin.login.button')}
            className="flex-auto md:flex-none h-[70px] !rounded-2xl px-8 py-4 !text-base md:!text-xl font-bold !leading-[1.3] md:!leading-[1.3] tracking-[0.02em] uppercase [overflow-wrap:anywhere] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#4f4898] focus-visible:outline-offset-4 disabled:cursor-wait disabled:transform-none"
            loading={submitting}
          />
        </form>
        {error && (
          <div role="alert" className="max-w-[38rem] mx-auto mt-[16px]">
            <Text type="xsmall" text={t('login.error')} className="text-red-20" />
          </div>
        )}
        {success && (
          <div role="status" className="max-w-[38rem] mx-auto mt-[16px]">
            <Text type="xsmall" text={t('login.success')} className="text-blue-20" />
          </div>
        )}
      </section>
    </AdminBrandLayout>
  );
};

export default AdminLogin;
